import React from 'react'

const BigFolderFaceIcon = props => {
  return (
    <svg
      width='200'
      height='201'
      viewBox='0 0 200 201'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <circle cx='100' cy='100' r='100' fill='#F8D8FF' />
      <g filter='url(#filter0_d_719_14792)'>
        <path
          d='M139.971 61.5663H105.617C104.42 61.5674 103.234 61.332 102.128 60.8737C101.022 60.4154 100.019 59.7433 99.1746 58.896L92.5269 52.2649C90.8569 50.5901 88.8704 49.2624 86.6824 48.3586C84.4944 47.4549 82.1484 46.9932 79.7803 47.0001H60.0291C55.2493 47.006 50.6669 48.9026 47.2871 52.274C43.9073 55.6454 42.0059 60.2163 42 64.9842V135.016C42.0059 139.784 43.9073 144.355 47.2871 147.726C50.6669 151.097 55.2493 152.994 60.0291 153H139.971C144.751 152.995 149.334 151.099 152.714 147.727C156.094 144.356 157.995 139.784 158 135.016V79.5281C157.991 74.7634 156.087 70.1968 152.708 66.8297C149.328 63.4626 144.748 61.5698 139.971 61.5663Z'
          fill='white'
        />
      </g>
      <circle cx='85' cy='102' r='3' fill='#B64FCD' />
      <circle cx='115' cy='102' r='3' fill='#B64FCD' />
      <rect x='92' y='121' width='16' height='8' rx='4' fill='#B64FCD' />
      <defs>
        <filter
          id='filter0_d_719_14792'
          x='10'
          y='31'
          width='180'
          height='170'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='16' />
          <feGaussianBlur stdDeviation='16' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_719_14792'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_719_14792'
            result='shape'
          />
        </filter>
      </defs>
    </svg>
  )
}

export default BigFolderFaceIcon
